// Fisher–Yates shuffle for question option randomization.
//
// Each PublicOption already carries a stable id (`opt-0`..`opt-3`) from the
// server, so the shuffled array doesn't need an index-mapping side table —
// the click handler reads `option.id` directly. Server-side compares that id
// against the canonical correct option id; correct_index never leaves the
// server.
//
// `rng` is optional. Tests inject a seeded PRNG (mulberry32) for determinism;
// production calls leave it undefined and use Math.random.

export function shuffle<T>(arr: readonly T[], rng: () => number = Math.random): T[] {
  const out = arr.slice()
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1))
    const tmp = out[i]!
    out[i] = out[j]!
    out[j] = tmp
  }
  return out
}

/**
 * Tiny seeded PRNG. Not crypto-grade — only used for deterministic tests.
 * Source: https://gist.github.com/tommyettinger/46a3b4c8ba1f59d6c4a0d57f1c87c4c7
 */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0
  return () => {
    a = (a + 0x6d2b79f5) | 0
    let t = a
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
